import { render, staticRenderFns } from "./EditorAccountPhoto.vue?vue&type=template&id=7b638eab&scoped=true&"
import script from "./EditorAccountPhoto.vue?vue&type=script&lang=js&"
export * from "./EditorAccountPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b638eab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b638eab')) {
      api.createRecord('7b638eab', component.options)
    } else {
      api.reload('7b638eab', component.options)
    }
    module.hot.accept("./EditorAccountPhoto.vue?vue&type=template&id=7b638eab&scoped=true&", function () {
      api.rerender('7b638eab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorAccountPhoto.vue"
export default component.exports